// extracted by css-extract-rspack-plugin
export default {"validationErrorTooltip":"sidebar-text-input-module__validationErrorTooltip__Y2KT9pI"};